import { useAuth } from "react-oidc-context";

// A wrapper for the the function passed to useQuery
// Provides currentUser's accessToken to the underlying api call invoked
// Also keeps the react-query devtools from being polluted with long token strings
const useAuthenticatedCall = (apiCall) => {
  const auth = useAuth();

  return (queryArguments) => {
    const {
      queryKey: [_key, requestParams],
      pageParam,
      meta,
      signal,
    } = queryArguments;

    return apiCall({
      ...requestParams,
      pageParam,
      meta,
      accessToken: auth.user?.access_token,
      signal,
    });
  };
};

export default useAuthenticatedCall;
